import { type FacetDimension, NOT_SET_KEY, valueOrNotSet } from "../../utils/facetFilters";
import { toAuditDate } from "./pbjGridFormat";

export enum DayType {
	Weekday = "weekday",
	Weekend = "weekend",
}

/** Sunday = 0 and Saturday = 6 (`weekdayISO`) — the same Sat/Sun rule as the backend's weekend split. */
const WEEKEND_DAYS: ReadonlySet<number> = new Set([0, 6]);

// DEFAULT: an empty string is as blank as null — both land on the one "Blank" option.
export const textFacet = <T>(id: string, get: (row: T) => string | null): FacetDimension<T> => ({ id, getKeys: (r) => valueOrNotSet(get(r) || null) });

// DEFAULT: a blank or unreadable date lands on the "Blank" option rather than vanishing from the facet.
export const monthFacet = <T>(id: string, get: (row: T) => unknown): FacetDimension<T> => ({
	id,
	getKeys: (r) => [toAuditDate(get(r))?.toFormat("yyyy-MM") ?? NOT_SET_KEY],
});

export const dayTypeFacet = <T>(id: string, get: (row: T) => unknown): FacetDimension<T> => ({
	id,
	getKeys: (r) => {
		const date = toAuditDate(get(r));
		if (!date) return [NOT_SET_KEY];
		return [WEEKEND_DAYS.has(date.weekdayISO) ? DayType.Weekend : DayType.Weekday];
	},
});

export const flagFacet = <T>(id: string, flags: Readonly<Record<string, (row: T) => boolean>>): FacetDimension<T> => ({
	id,
	getKeys: (r) => Object.keys(flags).filter((flag) => flags[flag](r)),
});
